var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatrixBubblecolors(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 420 585",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 283.618h383.209"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 434.132h383.209"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 343.823h383.209"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 494.338h383.209"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 584.646h383.209"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 313.721h383.209"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 464.235h383.209"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 554.543h383.209"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 373.926h383.209"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 404.029h383.209"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M84 524.44h383.209"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M102.669 617.749V265"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M305.439 617.749V265"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M183.779 617.749V265"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M386.549 617.749V265"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M143.225 617.749V265"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M345.994 617.749V265"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M224.33 617.749V265"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADADA",
    strokeWidth: 0.5,
    d: "M264.884 617.749V265"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 224.018,
    cy: 284.109,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.463,
    cy: 404.967,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.572,
    cy: 434.444,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.824,
    cy: 315.552,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 426.431,
    cy: 584.781,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.282,
    cy: 555.282,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.018,
    cy: 555.303,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.282,
    cy: 493.282,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.463,
    cy: 524.843,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 425.448,
    cy: 374.507,
    r: 12.282,
    fill: "#DF4B85"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.573,
    cy: 373.524,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.018,
    cy: 374.507,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.304,
    cy: 314.569,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.59,
    cy: 282.144,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.092,
    cy: 493.4,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.018,
    cy: 495.365,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.177,
    cy: 464.905,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.159,
    cy: 344.047,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.983,
    cy: 434.445,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.428,
    cy: 314.569,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.59,
    cy: 524.843,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.369,
    cy: 555.369,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.145,
    cy: 435.427,
    r: 7.369,
    fill: "#DF4B85"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.35,
    cy: 403.493,
    r: 2.948,
    fill: "#DF4B85"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 224.509,
    cy: 343.556,
    r: 2.948,
    fill: "#DF4B85"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.954,
    cy: 374.016,
    r: 2.948,
    fill: "#DF4B85"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.668,
    cy: 404.476,
    r: 2.948,
    fill: "#DF4B85"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.954,
    cy: 464.414,
    r: 2.948,
    fill: "#DF4B85"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.954,
    cy: 555.948,
    r: 2.948,
    fill: "#DF4B85"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.223,
    cy: 555.948,
    r: 2.948,
    fill: "#DF4B85"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 313.515,
    r: 5,
    fill: "#2C2664"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 464.515,
    r: 5,
    fill: "#2C2664"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 373.515,
    r: 5,
    fill: "#2C2664"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 374.515,
    r: 5,
    fill: "#2C2664"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 433.515,
    r: 5,
    fill: "#2C2664"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 388,
    cy: 313.515,
    r: 5,
    fill: "#2C2664"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 524.515,
    r: 5,
    fill: "#2C2664"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 184,
    cy: 524.515,
    r: 5,
    fill: "#2C2664"
  })));
}

export default "data:image/svg+xml;base64,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";
export { SvgMatrixBubblecolors as ReactComponent };